import { SidebarLayout } from '@/layouts/sidebar/SidebarLayout';
import { Helmet } from 'react-helmet-async';
import { Permission } from '@/models/user';

import { PageWithLayout } from '@/models/page';
import { B2BContent } from './components/B2BContent';
import { useAuthentication } from '@/hooks/useAuthentication';
import { useGetLiftOperatorQuery } from '@/api/v2/liftOperator';
import UnAuthorized from '@/pages/UnAuthorized';

const B2BPage: PageWithLayout = () => {
    const { liftOperatorData } = useAuthentication();
    const { data: liftoperator } = useGetLiftOperatorQuery({
        liftOperatorId: liftOperatorData?.liftOperatorId,
    });

    if (!liftoperator) {
        return null;
    }

    if (liftoperator.disableB2b) {
        return <UnAuthorized />;
    }

    return (
        <>
            <Helmet>
                <title>B2B | Starjack Admin</title>
            </Helmet>

            <B2BContent />
        </>
    );
};

B2BPage.isProtected = true;
B2BPage.permissions = [Permission.HOSPITALITY_NAV];
B2BPage.getLayout = (Component) => <SidebarLayout>{Component}</SidebarLayout>;

export default B2BPage;
